<template>
	<ul class="navbar-nav ml-auto align-items-lg-center">

		<li v-if="showLastweek" class="nav-item">
			<a href="/billing" class="nav-link lastweek-link">
				Ultima semana de suscripción al sistema,<br>te recomendamos abonar con tiempo
			</a>
		</li>

		<li class="nav-item">
			<a href="/downloads/list" class="btn bbutton" role="button">
				<i class="bi bi-file-earmark-arrow-down-fill bbutton-icon" title="Descargas"></i>
			</a>
		</li>

		<li class="nav-item">
			<a href="/news" class="btn bbutton position-relative" role="button" style="white-space:normal">
				<i class="bi bi-bell-fill bbutton-icon text-light" title="Notificaciones"></i>
				<span v-if="showCountNotifications > 0" class="badge badge-pill badge-danger notif-badge">
					{{ showCountNotifications }}
				</span>
			</a>
		</li>

		<li class="nav-item">
			<a href="#" class="btn bbutton" role="button" @click.prevent="toggleTheme" :title="isDark ? 'Modo claro' : 'Modo oscuro'">
				<i class="bi bbutton-icon" :class="isDark ? 'bi-sun' : 'bi-moon-stars'"></i>
			</a>
		</li>

		<li class="nav-item dropdown">
			<a class="nav-link dropdown-toggle" href="#" id="userMenuDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
				{{ user.name }}
			</a>
			<div class="dropdown-menu dropdown-menu-right" aria-labelledby="userMenuDropdown">
				<v-guard :permissions="['CONFIGURACION_PERFIL_EMPRESA']">
					<a class="dropdown-item" href="/configuracion/principal">Datos de mi empresa</a>
				</v-guard>
				<a class="dropdown-item" href="/mi-perfil">Cambiar contraseña</a>
				<a class="dropdown-item" href="/logout">Salir del sistema</a>
			</div>
		</li>

	</ul>

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
	computed: {
		...mapGetters({
			user: 'user/showUser',
			showCountNotifications: 'alerts/showCountNotifications',
			showLastweek: 'authUser/showLastweek',
			isDark: 'theme/isDark'
		}),
	},
	mounted(){
		this.getNotifications();
	},
	methods: {
		...mapActions({
			getNotifications: 'alerts/getNotifications',
			toggleTheme: 'theme/toggle'
		}),
	}
}
</script>
<style scoped>
	.bbutton {
		background-color: transparent;
		border: none;
		color: #ffffff;
		display: inline-flex;
		align-items: center;
		justify-content: center;
	}
	.bbutton:hover,
	.bbutton:focus {
		background-color: rgba(255, 255, 255, 0.12) !important;
		color: #ffffff;
	}
	.bbutton-icon {
		font-size: 1.25rem;
		line-height: 1;
	}
	.notif-badge {
		position: absolute;
		top: -4px;
		right: -4px;
	}
	.lastweek-link {
		font-size: 10px;
		text-align: center;
		line-height: 1.2;
	}
	.dropdown-toggle {
		color: rgba(255, 255, 255, 0.85);
	}
	.dropdown-toggle:hover,
	.dropdown-toggle:focus {
		color: #ffffff;
	}

	@media (max-width: 991.98px) {
		.navbar-nav.ml-auto {
			margin-left: 0 !important;
		}
		.nav-item {
			margin: 0.25rem 0;
		}
		.notif-badge {
			top: 0;
			right: auto;
			left: 2.25rem;
		}
	}
</style>

